import { plainToClass } from 'class-transformer';
import {
  API_FUNDING_SOURCE_CREATE,
  API_FUNDING_SOURCE_DELETE,
  API_FUNDING_SOURCE_FIND_ALL,
  API_FUNDING_SOURCE_FIND_ONE,
  API_FUNDING_SOURCE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { FundingSourceDto } from '../dto';
import { FindAllResponse } from '../types';

export class FundingSourceApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<FundingSourceDto>> {
    return this.httpClient
      .get(API_FUNDING_SOURCE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(FundingSourceDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<FundingSourceDto> {
    return this.httpClient
      .get(API_FUNDING_SOURCE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(FundingSourceDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<FundingSourceDto> {
    return this.httpClient
      .post(API_FUNDING_SOURCE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(FundingSourceDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<FundingSourceDto> {
    return this.httpClient
      .put(API_FUNDING_SOURCE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(FundingSourceDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_FUNDING_SOURCE_DELETE, {
      pathParams: { uuid }
    });
  }
}
